import repository from "../Repository";

export default {
  async getFacilityEvaGrpList(screenId) {
    const res = await repository.post(
      `vul_facility_evagrp_info`,
      {},
      {
        headers: { s: screenId }
      }
    );
    return res;
  },

  async registerFacilityEvaGrp(registerItem, screenId) {
    const res = await repository.post(`vul_facility_evagrp_ope`, registerItem, {
      headers: { s: screenId }
    });
    return res;
  },

  async updateFacilityEvaGrp(grpId, grpName, year, h, delFlg, screenId) {
    let payload = {
      manage_grp_id: grpId,
      manage_grp_name: grpName,
      hash: h,
      delete_flg: delFlg
    };
    if (screenId == "SF0604") {
      payload.year = year;
    }
    const res = await repository.patch(`vul_facility_evagrp_ope`, payload, {
      headers: { s: screenId }
    });
    return res;
  }
};
